// TheSystem.js

import React from 'react';
import {
  TrendingUp,
  User,
  BarChart3,
  Calendar,
  Zap,
  Shield,
} from 'lucide-react';
import './TheSystem.css';

function TheSystem() {
  const features = [
    {
      icon: <TrendingUp size={32} />,
      title: 'Trending Ideas',
      logic: 'REAL-TIME RELEVANCE',
      explanation:
        "We monitor what's being discussed in your industry right now. Your posts feel current and informed—not generic or outdated.",
      benefit: 'You look plugged-in, not behind the curve.',
    },
    {
      icon: <User size={32} />,
      title: 'Matched to Your Profile',
      logic: 'PERSONALIZED CONTEXT',
      explanation:
        'Ideas are filtered through your role, industry, and professional goals. Every suggestion is relevant to YOUR expertise.',
      benefit: 'Authentic by design, not by accident.',
    },
    {
      icon: <BarChart3 size={32} />,
      title: '7-Category Rotation',
      logic: 'STRATEGIC VARIETY',
      explanation:
        'Post across insights, stories, lessons, trends, leadership, behind-the-scenes, and hot takes. People recognize multi-dimensional profiles faster.',
      benefit: 'You look well-rounded, not one-note.',
    },
    {
      icon: <Zap size={32} />,
      title: 'Fast Publishing',
      logic: 'SPEED + SIMPLICITY',
      explanation:
        'Choose an idea, pick your tone and category, get a polished draft via email in 60 seconds. Edit if you want, or post as-is.',
      benefit: 'You save hours and stay consistent.',
    },
    {
      icon: <Calendar size={32} />,
      title: 'Your Schedule, Your Pace',
      logic: 'FLEXIBLE DELIVERY',
      explanation:
        'Choose how often you want ideas—daily, every 2 days, 3 days, or weekly. We adapt to your posting rhythm, not the other way around.',
      benefit: 'Consistency on your terms, zero pressure.',
    },
    {
      icon: <Shield size={32} />,
      title: 'You Stay in Control',
      logic: 'YOUR CHOICES, YOUR VOICE',
      explanation:
        'We suggest, you decide. No automated posting, no robotic content. You approve everything before it goes live.',
      benefit: 'Recognition without dependency.',
    },
  ];

  return (
    <section className='the-system' id='the-system'>
      <div className='system-container'>
        <div className='system-header'>
          <h2 className='system-title'>The Story Engine System</h2>
          <p className='system-subtitle'>
            A simple framework that makes you look smart by combining trending
            insights with strategic variety
          </p>
        </div>

        <div className='features-grid'>
          {features.map((feature, index) => (
            <div key={index} className='feature-card'>
              <div className='feature-icon'>{feature.icon}</div>
              <h3 className='feature-title'>{feature.title}</h3>
              <p className='feature-logic'>{feature.logic}</p>
              <p className='feature-explanation'>{feature.explanation}</p>
              <div className='feature-benefit'>{feature.benefit}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TheSystem;
